import { render, staticRenderFns } from "./VideoItemDetail.vue?vue&type=template&id=5e71b747&"
import script from "./VideoItemDetail.vue?vue&type=script&lang=js&"
export * from "./VideoItemDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports